import { createFileRoute, Navigate } from "@tanstack/react-router"
import { BackofficeScheduledReportsSearchSchema } from "./list/route"

export const Route = createFileRoute("/_base/_auth/backoffice/scheduledReports/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Navigate
      to="/backoffice/scheduledReports/list"
      search={BackofficeScheduledReportsSearchSchema.parse({})}
      replace
    />
  )
}
